import storeMaintain from './store-maintain'
import deliveryConfig from './delivery-config'
import openingHours from './opening-hours'

export default {
  namespaced: true,
  modules: {
    storeMaintain,
    deliveryConfig,
    openingHours,
  },
}
